export var clearPhoneNumber = function (phone) {
    if (!phone) {
        return null;
    }
    return phone.replace(/[+()\- ]/g, '');
};
